import { render, staticRenderFns } from "./TPAEmployeeDashboard.vue?vue&type=template&id=320a9fcd&scoped=true&"
import script from "./TPAEmployeeDashboard.vue?vue&type=script&lang=js&"
export * from "./TPAEmployeeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TPAEmployeeDashboard.vue?vue&type=style&index=0&id=320a9fcd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a9fcd",
  null
  
)

export default component.exports